import { ref, type Ref, type ComputedRef } from 'vue';
import type { Item } from '../types/main';
import type { EmitsEventName } from '../types/internal';

export default function useExpandableRow(
  items: Ref<Item[]>,
  prevPageEndIndex: ComputedRef<number>,
  emits: (event: EmitsEventName, ...args: unknown[]) => void,
) {
  const expandingItemIndexList = ref<number[]>([]);

  const updateExpandingItemIndexList = (
    expandingItemIndex: number,
    expandingItem: Item,
    event: Event,
  ) => {
    event.stopPropagation();
    const index = expandingItemIndexList.value.indexOf(expandingItemIndex);
    if (index !== -1) {
      expandingItemIndexList.value.splice(index, 1);
    } else {
      const currentPageExpandIndex = items.value.findIndex(
        (item) => JSON.stringify(item) === JSON.stringify(expandingItem),
      );
      emits(
        'expandRow',
        prevPageEndIndex.value + currentPageExpandIndex,
        expandingItem,
      );
      expandingItemIndexList.value.push(
        prevPageEndIndex.value + currentPageExpandIndex,
      );
    }
  };

  const clearExpandingItemIndexList = () => {
    expandingItemIndexList.value = [];
  };

  return {
    expandingItemIndexList,
    updateExpandingItemIndexList,
    clearExpandingItemIndexList,
  };
}
